import { render, staticRenderFns } from "./ProductDescription.vue?vue&type=template&id=51381c0d&scoped=true"
import script from "./ProductDescription.vue?vue&type=script&lang=js"
export * from "./ProductDescription.vue?vue&type=script&lang=js"
import style0 from "./ProductDescription.vue?vue&type=style&index=0&id=51381c0d&prod&lang=css"
import style1 from "./ProductDescription.vue?vue&type=style&index=1&id=51381c0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51381c0d",
  null
  
)

export default component.exports